/**
 * Transform branch group
 * @param {Object} input branch group
 * @returns {Object} branch group
 */
export const transformBranchGroup = (input = {}) => {
	return {
		id: input.id || '',
		name: input.name || '',
	};
};

/**
 * Transform branch groups
 * @param {Array} input branch groups
 * @returns {Array} branch groups
 */
export const transformBranchGroups = (input = []) => {
	return input.map((item) => transformBranchGroup(item));
};
